// extracted by mini-css-extract-plugin
module.exports = {"bold":"wx_wy"};